import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { LocationModel } from 'src/app/models/container_master_model/location';
import { BackendListModel } from '../../models/common/list.model';
import { Observable } from 'rxjs';
import { DepotMasterTab1 } from 'src/app/models/Depot_Master_Model/depot-master-tab1';

@Injectable({
  providedIn: 'root'
})
export class LocationApiService {
  base_url = ApiRoutes.Location;
  base_url1 = ApiRoutes.DepotMaster;
  searchTerm = '';
  constructor(
    private http: HttpClient
  ) { }
  getDepotLocation(): Observable<BackendListModel<LocationModel>> {
    let url = `${this.base_url}?location_type_name=depot`;
    return this.http.get<BackendListModel<LocationModel>>(url);
  }

  getDepot(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<DepotMasterTab1>> {
    let url = `${this.base_url}?location_type_name=depot`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<DepotMasterTab1>>(String(urlObj));
  }
  //for Testing
  getDepotTest(id): Observable<BackendListModel<DepotMasterTab1>> {
    let url = `${this.base_url}?location_type_name=depot/${id}`;
    return this.http.get<BackendListModel<DepotMasterTab1>>(url);
  }

  getPortLocation(): Observable<BackendListModel<LocationModel>> {
    let url = `${this.base_url}?location_type_name=port`;
    return this.http.get<BackendListModel<LocationModel>>(url);
  }
  getDepotbyDOowner(): Observable<BackendListModel<LocationModel>> {
    let url = `${this.base_url1}location_short/`;
    return this.http.get<BackendListModel<LocationModel>>(url);
  }

  // createLocation(data: any): Observable<BackendListModel<LocationModel>> {
  //   let url = `${this.base_url}`;
  //   return this.http.post<BackendListModel<LocationModel>>(url);
  // }


}